import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "button"];

  connect() {
    this.updateButtonState();
  }

  updateButtonState() {
    if (this.inputTarget.value.trim() !== "") {
      this.buttonTarget.classList.add("is-active");
    } else {
      this.buttonTarget.classList.remove("is-active");
    }
  }

  clearInput() {
    this.inputTarget.value = "";
    this.updateButtonState();
    this.inputTarget.dispatchEvent(new Event('input'));
  }
}
